import type { VitaDocumentCvFragment } from '@xing-com/crate-lebenslauf-graphql';

import type { ProgressBarState } from './types';

export const getProgressBarState = ({
  cv,
  progressBarState,
}: {
  cv: VitaDocumentCvFragment;
  progressBarState: ProgressBarState;
}): ProgressBarState => ({
  personalInformation: {
    ...progressBarState.personalInformation,
    isFilled: !!(
      cv?.personalInformation?.firstName &&
      cv.personalInformation?.lastName &&
      cv.personalInformation?.country &&
      cv.personalInformation?.email
    ),
  },
  professionalExperience: {
    ...progressBarState.professionalExperience,
    isFilled: !!(
      cv?.professionalExperience &&
      cv.professionalExperience.length &&
      cv.professionalExperience[0]?.occupation &&
      cv.professionalExperience[0].company &&
      cv.professionalExperience[0].discipline &&
      cv.professionalExperience[0].jobLevel &&
      cv.professionalExperience[0].startDate
    ),
  },
  educationExperience: {
    ...progressBarState.educationExperience,
    isFilled: !!(
      cv?.educationExperience &&
      cv.educationExperience.length &&
      cv.educationExperience[0]?.startDate &&
      cv.educationExperience[0].courseOfStudy
    ),
  },
  skills: {
    ...progressBarState.skills,
    isFilled: !!(cv?.skills && cv.skills.length >= 2),
  },
  summary: {
    ...progressBarState.summary,
    isFilled: !!cv?.aboutMe,
  },
});
